/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'contracts';
  },
});
